import React, { useState } from 'react';
import PropTypes from 'prop-types';

import StandardModal from 'components/consumer/StandardModal';
import useScreen from 'hooks/useScreen';
import KeySellingPointsBarItem from '../KeySellingPointsBarItem';
import PremiumDeliveryIcon from '../icons/PremiumDeliveryIcon';

const itemTitle = 'Premium In-Home Delivery';
const itemContent =
  'A premium in-home service will deliver your order on a pre-scheduled date. The delivery team will move and unpack your order to the room of your choice and dispose of all packaging. Please note: Not all items are eligible for in-home service. Price dependent on your location.';

const DeliveryItem = ({ openMobileModal }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isMobileOrTablet } = useScreen();

  return (
    <>
      <KeySellingPointsBarItem
        icon={<PremiumDeliveryIcon color="currentColor" />}
        onClick={() => {
          if (isMobileOrTablet) {
            openMobileModal({
              content: itemContent,
              icon: <PremiumDeliveryIcon color="white" />,
            });
          } else {
            setIsOpen(true);
          }
        }}
      >
        {itemTitle}
      </KeySellingPointsBarItem>

      <StandardModal
        isOpen={isOpen}
        icon={<PremiumDeliveryIcon color="white" />}
        onClose={() => {
          setIsOpen(false);
        }}
        title={itemTitle}
      >
        {itemContent}
      </StandardModal>
    </>
  );
};

DeliveryItem.propTypes = {
  openMobileModal: PropTypes.func,
};

export default DeliveryItem;
